import * as Types from "@clockwise/schema";

import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type WebSettingsOrganizationSettingsQueryQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type WebSettingsOrganizationSettingsQueryQuery = {
  __typename: "Query";
  viewer: {
    __typename: "Viewer";
    user: {
      __typename: "User";
      orgs: {
        __typename: "OrgConnection";
        edges: Array<{
          __typename: "OrgEdge";
          node: { __typename: "Org"; id: string } | null;
        } | null> | null;
      };
    } | null;
  };
};

export const WebSettingsOrganizationSettingsQueryDocument = ({
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "WebSettingsOrganizationSettingsQuery" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "orgs" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown) as DocumentNode<
  WebSettingsOrganizationSettingsQueryQuery,
  WebSettingsOrganizationSettingsQueryQueryVariables
>;
